import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Road, RoadDirection } from '../models/select-road.model';
import { Observable } from 'rxjs/internal/Observable';
import { RoadsConfiguration } from '../models/roads-configuration.model';

@Injectable({
  providedIn: 'root',
})
export class SelectRoadService {
  constructor(private http: HttpClient) {}

  public getRoads(): Observable<Road[]> {
    return this.http.get<Road[]>(environment.apiConfig.uri + '/v1/roads');
  }

  public getRoadsConfiguration(): Observable<RoadsConfiguration[]> {
    return this.http.get<RoadsConfiguration[]>(environment.apiConfig.uri + '/v1/roads/configuration');
  }

  public getRoadDirectionsByRoad(road: Road, bothDirections: boolean): Observable<RoadDirection[]> {
    return this.http.get<RoadDirection[]>(environment.apiConfig.uri + `/v1/road-directions/${road.id}?both=${bothDirections}`);
  }

  public getRoadDirections(): Observable<RoadDirection[]> {
    return this.http.get<RoadDirection[]>(environment.apiConfig.uri + '/v1/road-directions');
  }

  public createRoad(road: Road): Observable<Road> {
    return this.http.post<Road>(environment.apiConfig.uri + '/v1/roads', road);
  }

  public updateRoad(road: Road): Observable<Road> {
    return this.http.patch<Road>(environment.apiConfig.uri + `/v1/roads/${road.id}`, road);
  }

  public deleteRoad(roadId: string): Observable<void> {
    return this.http.delete<void>(environment.apiConfig.uri + `/v1/roads/${roadId}`);
  }
}
